module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/xmas-c62805c703a7bba2e53d44dae9c4289b.svg";